module.exports = __webpack_public_path__ + "assets/f2e79f09ce2bf9c1f7619212e153811f.mp3";